import { CrudModel } from './_crud';

export class AppointmentStatusModel extends CrudModel {
  constructor() {
    super('app/appointmentstatus');
  }
}

export default new AppointmentStatusModel();
